import { useEffect } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { QrCode, X } from "lucide-react";
import { lenisRef } from "@/lib/smooth";

export const CatalogModal = ({ src, title, onClose }) => {
  useEffect(() => {
    lenisRef.current?.stop();
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      lenisRef.current?.start();
    };
  }, [onClose]);

  return createPortal(
    <motion.div
      data-testid="cake-catalog-modal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={onClose}
      className="fixed inset-0 z-[85] flex items-center justify-center bg-espresso/95 p-5 backdrop-blur-md"
    >
      <button data-testid="cake-catalog-close" onClick={onClose} aria-label="Cerrar" className="absolute right-4 top-4 rounded-full border border-gold/40 p-3 text-cream hover:bg-gold hover:text-espresso">
        <X size={18} />
      </button>
      <motion.div initial={{ scale: 0.94, y: 10 }} animate={{ scale: 1, y: 0 }} onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-3xl border border-gold/30 bg-roast p-4 text-center">
        <p className="font-sans text-sm text-sand">Escanea el código con la cámara de tu celular.</p>
        <div className="mt-3 overflow-hidden rounded-2xl bg-white">
          {src ? (
            <img data-testid="cake-catalog-img" src={src} alt={title} className="mx-auto max-h-[78vh] w-full object-contain" />
          ) : (
            <div className="flex aspect-square flex-col items-center justify-center gap-3 text-espresso">
              <QrCode size={72} />
              <p className="font-sans text-sm">Imagen del QR pendiente</p>
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>,
    document.body
  );
};
